import { Snackbar, SNACKBAR_TYPES } from "@lysaab/ui-2";
import React from "react";
import { FormattedMessage } from "react-intl";
export const LysaCanceled = () => {
    return (React.createElement("div", { className: "snackbar-wrapper" },
        React.createElement(Snackbar, { type: SNACKBAR_TYPES.ERROR, icon: true },
            React.createElement(FormattedMessage, { id: "onfido.status.poa.lysa_canceled" }))));
};
